// extracted by mini-css-extract-plugin
export default {"container":"SecurityNavItem-module--container--e25ae","content":"SecurityNavItem-module--content--ad781","icon":"SecurityNavItem-module--icon--de793"};